import {Command} from "./Command";
import {GamePlay} from "../model/game-play";
import {FirstDownCommand} from "./FirstDownCommand";
import {SwitchTeamsCommand} from "./SwitchTeamsCommand";

export class ApplyDownRulesCommand implements Command {
  private commands: Command[] = [];

  constructor(
    private gamePlay: GamePlay,
    private lastGamePlay: GamePlay,
    private numberOfDowns: number
  ) { }

  execute() {
    console.log('COMMAND ApplyDownRulesCommand')

    if (this.gamePlay.distance === undefined) {
      throw new Error('GamePlay sans distance')
    }

    if (this.gamePlay.distance <= 0) {
      this.commands.push(
        new FirstDownCommand(this.gamePlay))
    } else if (this.gamePlay.down > this.numberOfDowns) {
      this.commands.push(
        new SwitchTeamsCommand(this.gamePlay, this.lastGamePlay))
    }

    console.group('Executer sous commandes')
    for (const command of this.commands) {
      command.execute();
    }
    console.groupEnd()
  }
}
